import { PriorityOption } from "../interfaces/priority.model"

export const PriorityData = {
    CRITICAL: { id: 0, text: $localize`:@@critical:Critical` },
    HIGH: { id: 1, text: $localize`:@@high:High` },
    MEDIUM: { id: 2, text: $localize`:@@medium:Medium` },
    LOW: { id: 3, text: $localize`:@@low:Low` },
}

const IconCritical = '../../assets/images/icons/bookmark-icon.svg';
const IconHigh = '../../assets/images/icons/arrow-up-tripple-icon.svg';
const IconMedium = '../../assets/images/icons/arrow-up-double-icon.svg';
const IconLow = '../../assets/images/icons/arrow-up-icon.svg';


export const PrioritiesConfig: PriorityOption[] = [
    {
        value: PriorityData.CRITICAL,
        icon: IconCritical,
        color: "#910999",
    },
    {
        value: PriorityData.HIGH,
        icon: IconHigh,
        color: "var(--danger-color)",
    },
    {
        value: PriorityData.MEDIUM,
        icon: IconMedium,
        color: "var(--warning-color)",
    },
    {
        value: PriorityData.LOW,
        icon: IconLow,
        color: "var(--success-color)",
    },
]

export const PrioritiesLookup = [
    PriorityData.CRITICAL,
    PriorityData.HIGH,
    PriorityData.MEDIUM,
    PriorityData.LOW
]

